import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const TopNav = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/", label: "The Invitation" },
    { to: "/gallery", label: "The Night" },
  ];

  return (
    <nav
      data-testid="top-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#D4AF37]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[56px] md:h-[64px] flex items-center justify-center gap-6 md:gap-10">
        {links.map((l, idx) => {
          const active =
            l.to === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(l.to);
          return (
            <div key={l.to} className="flex items-center gap-6 md:gap-10">
              <Link
                to={l.to}
                data-testid={`nav-link-${l.to.replace(/[^a-z]/gi, "") || "home"}`}
                className="group relative py-2 text-[11px] md:text-xs tracking-[0.4em] uppercase transition-colors duration-300"
                style={{ color: active ? "#D4AF37" : "#FDFBF7" }}
              >
                {l.label}
                <span
                  aria-hidden="true"
                  className="absolute -bottom-0.5 left-0 right-0 mx-auto h-px bg-[#D4AF37] transition-all duration-300"
                  style={{ width: active ? "100%" : "0%" }}
                />
              </Link>
              {idx === 0 && (
                <span className="text-[#D4AF37]/40" aria-hidden="true">
                  ·
                </span>
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
};
